import { yupResolver } from '@hookform/resolvers/yup';
import { enqueueSnackbar } from 'notistack';
import React, { FC } from 'react';
import { useForm } from 'react-hook-form';
import { Trans, useTranslation } from 'react-i18next';

import { useAuthStore } from 'common/stores';
import { CodeInput } from 'core/components/form';
import { CircularIndicator } from 'core/components/uikit';

import { OtpVerifyFormData, otpVerifySchema } from './validationSchema';

export type OtpVerifyFormProps = {
  otpAccessToken: string;
  onSubimit: (values: OtpVerifyFormData) => Promise<void>;
};

const OtpVerifyForm: FC<OtpVerifyFormProps> = ({
  onSubimit,
  otpAccessToken,
}) => {
  const { t } = useTranslation();

  const {
    control,
    handleSubmit,
    formState: { isValid, isSubmitting },
  } = useForm<OtpVerifyFormData>({
    resolver: yupResolver(otpVerifySchema),
    mode: 'all',
    defaultValues: { code: '' },
  });

  const isButtonDisabled = !isValid || isSubmitting;

  const onSubmit = handleSubmit(onSubimit);

  const resendCode = async () => {
    const success = await useAuthStore
      .getState()
      .resendOtpCode({ otpAccessToken });

    if (!success) return;

    enqueueSnackbar(t('notify.resendCode'), {
      variant: 'success',
      hideIconVariant: true,
    });
  };

  return (
    <form className="flex flex-col" onSubmit={onSubmit}>
      <CodeInput name="code" control={control} />
      <button type="submit" className="mb-4" disabled={isButtonDisabled}>
        {isSubmitting ? <CircularIndicator /> : t('pages.otpVerify.action')}
      </button>
      <p className="text-center text-[12px]">
        <Trans
          i18nKey="pages.otpVerify.helperText"
          components={{
            button: (
              <b className="cursor-pointer text-primary" onClick={resendCode} />
            ),
          }}
        />
      </p>
    </form>
  );
};

export default OtpVerifyForm;
